import { takeLatest } from "redux-saga/effects";
import { postAddTenantUserRequestSaga } from "./saga";
import { POST_ADD_USER_REQUEST } from "../const";

export default function* watchAddTenantUser() {
  yield takeLatest(POST_ADD_USER_REQUEST, postAddTenantUserRequestSaga);
}
